import React, { useEffect, useState } from "react";
import CookieBanner from "./components/CookieBanner";
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from "react-router-dom";
import { io } from "socket.io-client";
import { HelmetProvider } from 'react-helmet-async';
import ReactGA from "react-ga4"; //
import Home from "./pages/Home";
import HostGame from "./pages/HostGame";
import Ranked from "./pages/Ranked";
import Rules from "./pages/Rules";
import Account from "./pages/Account";
import Leaderboard from "./pages/Leaderboard";
import PublicProfile from "./pages/PublicProfile";
import NotFound from "./pages/NotFound";

const socket = io();

function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    // Sende die aktuelle Seite (z.B. "/host" oder "/shop") an Google
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
  }, [location]);

  return null; // Dieses Bauteil ist unsichtbar
}

export default function App() {
  // NEU: State, um zu wissen, ob ein Spiel läuft
  const [isGameActive, setIsGameActive] = useState(false);

  useEffect(() => {
    socket.on("connect", () => console.log("🟢 Connected! ID:", socket.id));
    return () => socket.off("connect");
  }, []);

  useEffect(() => {
    if (!socket) return;
    
    socket.on("game_invite_received", ({ roomCode, hostName }) => {
      // Ein natives Browser-Popup (Können wir später hübscher machen)
      const accept = window.confirm(`🎮 ${hostName} hat dich in eine Lobby eingeladen! Möchtest du beitreten?`);
      if (accept) {
        window.location.href = `/host?code=${roomCode}`;
      }
    });

    return () => socket.off("game_invite_received");
  }, [socket]);

  return (
    <HelmetProvider>
      <Router>

        <AnalyticsTracker />
        <CookieBanner/>

        <div style={{ backgroundColor: "#111", minHeight: "100vh", fontFamily: "sans-serif" }}>
          
          {/* Navbar wird ausgeblendet, wenn isGameActive true ist */}
          {!isGameActive && (
            <nav style={{ display: "flex", gap: "20px", padding: "20px", backgroundColor: "#222", borderBottom: "2px solid gold", justifyContent: "center" }}>
              <Link to="/" style={navLinkStyle}>HOME</Link>
              <Link to="/host" style={navLinkStyle}>HOST GAME</Link>
              <Link to="/ranked" style={navLinkStyle}>RANKED</Link>
              <Link to="/leaderboard" style={navLinkStyle}>LEADERBOARD</Link>
              <Link to="/rules" style={navLinkStyle}>RULES</Link>
              <Link to="/account" style={navLinkStyle}>ACCOUNT</Link>
            </nav>
          )}

          <Routes>
            <Route path="/" element={<Home />} />
            {/* NEU: Wir geben setIsGameActive als Prop an HostGame weiter */}
            <Route path="/host" element={<HostGame socket={socket} setIsGameActive={setIsGameActive} />} />
            <Route path="/ranked" element={<Ranked socket={socket} setIsGameActive={setIsGameActive} />} />
            <Route path="/leaderboard" element={<Leaderboard/>}/>
            <Route path="/rules" element={<Rules />} />
            <Route path="/account" element={<Account socket={socket} setIsGameActive={setIsGameActive} />} />
            <Route path="/account/:username" element={<PublicProfile />} />
            <Route path="*" element={<NotFound />} />
          </Routes>

        </div>
      </Router>
    </HelmetProvider>
  );
}

const navLinkStyle = {
  color: "white", textDecoration: "none", fontWeight: "bold", fontSize: "1.2em", padding: "10px"
};